import "./ResultPage.scss";
import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Checkbox4 from "./componenent/checkbox/Checkbox4";
import moment from "moment";
import { SocketState } from "../context/SocketProvider";

function ResultPage() {
    const navigate = useNavigate();
    const { socket } = SocketState();
    const [resultData, setResultData] = useState([]);
    const [fromDate, setfromDate] = useState(moment().format("YYYY-MM-DD"));
    const [series, setSeries] = useState("0");
    const [field, setField] = useState([
        { label: "0", Checked: true, id: 0 },
        { label: "1", Checked: false, id: 1 },
        { label: "2", Checked: false, id: 2 },
        { label: "3", Checked: false, id: 3 },
        { label: "4", Checked: false, id: 4 },
        { label: "5", Checked: false, id: 5 },
        { label: "6", Checked: false, id: 6 },
        { label: "7", Checked: false, id: 7 },
        { label: "8", Checked: false, id: 8 },
        { label: "9", Checked: false, id: 9 },  

    ]);


    console.log("Selected series:", resultData);
    const selectedField = field.find((f) => f.Checked);
        console.log(
            selectedField
        )
    // ✅ Handle Checkbox Click
    const handleCheck = (id) => {
        const updated = field.map((f) => ({ ...f, Checked: f.id === id }));
        setField(updated);
        const selected = updated.find((f) => f.Checked);
        if (selected) setSeries(selected.label);
    };

    // ✅ Socket connect + data request
    useEffect(() => {
        if (!socket) return;

        socket.emit("req", {
            en: "MINI_LOTTERY_FILTER_RESULTS_HISTORY",
            data: { series, date: fromDate },
        });

        const handleResponse = (response) => {
            if (response.en === "MINI_LOTTERY_FILTER_RESULTS_HISTORY") {
                // console.log("Response data type:", typeof response.data, response.data);

                // ✅ Make sure resultData is always an array
                if (Array.isArray(response.data)) {
                    setResultData(response.data);
                } else if (response.data && typeof response.data === "object") {
                    // Sometimes backend sends object like { results: [...] }
                    const possibleArray = Object.values(response.data);
                    setResultData(
                        Array.isArray(possibleArray[0]) ? possibleArray[0] : possibleArray
                    );
                } else {
                    setResultData([]);
                }
            }
        };

        socket.on("res", handleResponse);
        return () => socket.off("res", handleResponse);
    }, [socket, series, fromDate]);

    return (
        <div className="myaccount_content">
            {/* Header: Date + Series */}
            <div className="flex items-center">
                <div className="w-full flex flex-wrap gap-2 items-center px-2 py-2">
                    {/* <div>
                        <label className="block text-sm font-bold mb-1">From</label>
                        <input
                            type="date"
                            value={fromDate}
                            onChange={(e) => setfromDate(e.target.value)}
                            className="border rounded px-3 py-2"
                            max={moment().format('YYYY-MM-DD')}
                            min="2023-04-01"
                        />
                    </div> */}
                    <div className="flex items-center">
                        {field.map((check) => (
                            <div className="flex items-center mx-2" key={check.id}>
                                <Checkbox4
                                    checked={check.Checked}
                                    id={check.id}
                                    onChange={() => handleCheck(check.id)}
                                />
                                <span className="ml-1">{check.label * 10}</span>
                            </div>
                        ))}
                    </div>
                    {/* <button
                        onClick={() => navigate("/result")}
                        className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-1 px-3 text-sm rounded-lg"
                    >
                        10/30/50
                    </button> */}
                    <button
                        onClick={() => navigate("/result1d")}
                        className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-1 px-3 text-sm rounded-lg"
                    >
                        2D
                    </button>

                    <button
                        onClick={() => navigate("/result3d")}
                        className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-1 px-3 text-sm rounded-lg"
                    >
                        3D
                    </button>

                    <button
                        onClick={() => navigate("/result2d")}
                        className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-1 px-3 text-sm rounded-lg"
                    >
                        4D
                    </button>

                    
                    <button
                        onClick={() => navigate("/resultPana")}
                        className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-1 px-3 text-sm rounded-lg"
                    >
                        Pana
                    </button>


                    {/* <button
                        onClick={() => navigate('/resultTitli')}
                        className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-1 px-3 text-sm rounded-lg"
                    >
                        Titli
                    </button> */}
                    <button
                        onClick={() => navigate(-1)}
                        className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-1 px-3 text-sm rounded-lg"
                    >
                        Back
                    </button>
                </div>
            </div>

            {/* Table */}
            <div className="history_table_div h-full overflow-x-auto">
                <table className="table-auto w-full border-collapse ">
                    <thead className="sticky top-0 bg-gray-200">
                        <tr className="">
                            <th className="p-2 border border-[#000]">GAME TIME</th>
                            {[...Array(10)].map((_, idx) => (
                                <th
                                    colSpan={4}
                                    className={`game_result_his${idx + 1} border border-[#000]`}
                                    key={idx}
                                >
                                    {" "}
                                    {selectedField?.label && (
                                        <div className="res_th_head1">
                                            {selectedField?.label * 10 + idx}
                                        </div>
                                    )}{" "}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {resultData.length === 0 ? (
                            <tr>
                                <td
                                    colSpan={11}
                                    className="text-center py-4 border border-[#000]"
                                >
                                    No Data Found
                                </td>
                            </tr>
                        ) : (
                            resultData.map((result, i) => (
                                <tr key={i} className="border-separate border-spacing-1">
                                    <td className="border border-gray-300 dark:border-gray-600 border-[#000] p-2">
                                        {result.time}
                                    </td>
                                    {Object.values(result.result || {}).map((numbers, idx) => (
                                        <td
                                            colSpan={4}
                                            className={`game_result_his${idx + 1
                                                } border border-gray-300 dark:border-gray-600 border-[#000] p-1`}
                                        >
                                            <React.Fragment key={idx}>
                                                {[0, 1, 2, 3].map((index) => {
                                                    const value = numbers?.[index] ?? "--";
                                                    const isDouble =
                                                        /^\d{2}$/.test(value) && value[0] === value[1];
                                                    const bgColors = [
                                                        "#a9a9a9ff",
                                                        "#a9a9a9ff",
                                                        "#a9a9a9ff",
                                                        "#FFF68F",
                                                    ];
                                                    return (
                                                        <td
                                                            key={index}
                                                            className="p-2 border text-center border border-[#000]"
                                                            style={{
                                                                background: bgColors[index],
                                                                color: isDouble ? "red" : "#000",
                                                                fontWeight: isDouble ? "900" : "bold",
                                                            }}
                                                        >
                                                            {value || "--"}
                                                        </td>
                                                    );
                                                })}
                                            </React.Fragment>
                                        </td>
                                    ))}
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ResultPage;
